<template>
  <div
    class="eventComp_mode_25 eventComp_mode_container"
    v-show="currThemeObj"
    ref="tableParentDom"
  >
    <span class="eventComp_mode_title" v-text="'技术统计'"></span>
    <div class="tableScrollArea">
      <div class="tableGroup" v-for="group in tableGroup" :key="group.key">
        <div class="groupInfor">
          <span
            class="groupInfor_logo"
            :class="group.team_logo ? 'isLogo' : ''"
          >
            <img v-if="group.team_logo" :src="group.team_logo" />
          </span>
          <span
            class="groupInfor_name"
            v-text="_valPerFormatHandler(group.team_name)"
            @click="goDetail('CSMeetDelegationDetailIndex', group)"
          ></span>
        </div>
        <template v-if="isShowMode_25">
          <multiLevelFold_table
            :currThemeObj="currThemeObj"
            :currCid="currCid"
            :currSid="currSid"
            :sportsId="currSportsDetail.sportsId"
            :tableMode="tableMode"
            :parentWidthPx="parentWidthPx"
            :isScrollFlag="isScrollFlag"
            :variableColWidthVw="variableColWidthVw"
            :tableCellDefaultWidthVw="tableCellDefaultWidthVw"
            :defaultWidthVwNum="defaultWidthVwNum"
            :tableColumnData="tableColumnData"
            :tableData="group.tableData"
            @toParentEvent="toParentEventHandler"
            v-show="group.tableData && group.tableData.length > 0"
          ></multiLevelFold_table>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
// 适用： 足球 主客队 技术统计 表格（没有单元格合并，只是动态列）
import multiLevelFold_table from '@components/platfromBase/compreSportsMeet/table/multiLevelFold_table.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'eventComp_mode_25',
  components: {
    multiLevelFold_table,
  },
  props: {
    currSportsDetail: {
      type: Object,
      default: () => ({}),
    },
    sportsTypeArr: {
      type: Array,
      default: () => {
        return []
      },
    },
    datas: {
      type: Object,
      default: () => ({}),
    },
  },
  mixins: [cup_base_data_mixin],
  watch: {
    datas: {
      handler(newVal, oldVal) {
        console.debug('mode_25 刷新数据:', newVal, oldVal)
        if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
          this.init()
        }
      },
      //   immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      tableMode: 'eventComp_mode_25',
      currModeName: '',
      parentWidthPx: 0,
      parentHeightPx: 0,
      isScrollFlag: true,
      isClickFlag: false,
      variableColWidthVw: 13.88,
      tableCellDefaultWidthVw: 5.5,
      defaultWidthVwNum: null,
      renderModeList: [
        {
          modeName: 'eventComp_mode_25_FBL',
          sportsIdArr: [
            'FBL',
            'VBV',
            'BK3',
            'HBL',
            'HOC',
            'BBL',
            'SBL',
            'RUG',
            'CKT',
            'RU7',
            'BDM',
          ],
          tableGroup: ['home', 'away'],
          textAlignleftPropArr: ['single-player-name'],
          datasChildKey: 'athleteStats', //datas下需要的数据字段
        },
      ],
      tableGroup: null,
      tableColumnData: [],
      //   columnColorPropArr: [],
      textAlignleftPropArr: [],
    }
  },
  computed: {
    isShowMode_25() {
      let flag = false

      if (this.tableGroup && this.tableGroup.length > 0) {
        this.tableGroup.forEach((group) => {
          if (group.tableData && group.tableData.length > 0) {
            flag = true
          }
        })
      }
      return flag
    },
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.onResizeEvent()
    })
    this.init()
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {
      this.onResizeEvent()
    })
  },
  methods: {
    async init() {
      this.$nextTick(() => {
        this.onResizeEvent()
        // this.computedModeData({})
        if (this.currSportsDetail && this.currSportsDetail.sportsId) {
          this.renderModeList.forEach((modeItem) => {
            if (modeItem.sportsIdArr.includes(this.currSportsDetail.sportsId)) {
              this.currModeName = modeItem.modeName
              //   this.columnColorPropArr = modeItem.columnColorPropArr
              this.textAlignleftPropArr = modeItem.textAlignleftPropArr

              const table_headArr =
                this.datas[modeItem.datasChildKey].table_head

              // 表头
              const headColumns = []
              table_headArr.forEach((colums, colIndex) => {
                if (colums && colums.map_key_arr.length > 0) {
                  let obj = {}
                  if (colums.map_key_arr[0] === 'bib_number') {
                    obj = {
                      colKey: colums.map_key_arr[0]
                        ? colums.map_key_arr[0]
                        : '',
                      colTitle: 'No.',
                      widthVw: 3.75,
                      fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
                    }
                  } else {
                    obj = {
                      colKey: colums.map_key_arr[0]
                        ? colums.map_key_arr[0]
                        : '',
                      colTitle: colums.name ? colums.name : '',
                      widthVw: this.tableCellDefaultWidthVw,
                    }
                  }
                  headColumns.push(obj)
                }
              })

              const customColumn = {
                prop: 'single-player-name', //fristColumnPropArr.join('-'),
                label: '运动员',
                widthVw: this.variableColWidthVw, //对应列的宽度，单位vw
                className: 'columnTextLeftClass', //单独定制的头部样式class
                fixed: 'left',
              }

              console.debug('headColumns:', headColumns)
              let tableColumnData = []
              // let widthVw = this.tableCellDefaultWidthVw
              for (let i = 0; i < headColumns.length; i++) {
                const item = headColumns[i]
                if (['运动员', '姓名', '国家/地区'].includes(item.colTitle)) {
                  // 特殊列
                  tableColumnData.push(customColumn)
                } else {
                  // 普通列
                  let className = ''
                  let prop = item.colKey
                  tableColumnData.push({
                    prop: prop,
                    label: item.colTitle,
                    widthVw: item.widthVw,
                    className,
                    selected: '',
                    fixed: item.fixed ? item.fixed : '',
                  })
                }
              }

              console.debug('tableColumnData:', tableColumnData)
              this.tableColumnData = tableColumnData
              this.defaultWidthVwNum = tableColumnData.length - 2 //[减去 运动员和球衣号 2列]

              console.debug('mode_25', this.tableColumnData)
              // 篮球 modeItem.datasChildKey:athleteStats
              this.tableGroup = modeItem.tableGroup.map((groupKey) => {
                console.debug(
                  'mode_25',
                  groupKey,
                  this.datas[groupKey].team_name,
                  modeItem.datasChildKey
                )
                const baseInfo = {
                  team_name: this.datas[groupKey].team_name,
                  team_eng: this.datas[groupKey].team_eng,
                  team_logo: this.datas[groupKey].team_logo,
                  team_id: this.datas[groupKey].team_id
                    ? this.datas[groupKey].team_id
                    : '',
                }

                const { team_logo, team_name, team_id, team_eng } = baseInfo
                return {
                  key: groupKey,
                  tableData: this.datas[modeItem.datasChildKey]
                    ? JSON.parse(
                        JSON.stringify(
                          this.datas[modeItem.datasChildKey][groupKey]
                        )
                      )
                    : [],
                  team_logo,
                  team_name,
                  team_id,
                  team_eng,
                }
              })
              console.debug(
                'this.tableGroup:',
                this.tableGroup,
                this.tableColumnData,
                this.parentWidthPx
              )
            }
          })
        }
      })
    },
    goDetail(routerName, item, id) {
      let query = {}
      if (routerName == 'CSMeetPlayerDetailIndex') {
        query.playerId = item ? item.player_id : id
      }
      if (routerName == 'CSMeetDelegationDetailIndex') {
        query.delegationId = item ? item.team_id : id
      }
      this.pageJump(this.$router, `${routerName}_${this.currCid}`, query)
    },
    _valPerFormatHandler(val, ceil) {
      let data
      if (val === undefined || val === null || val === '' || val === ' ') {
        return '-'
      }
      data = `${val}${ceil ? ceil : ''}`
      return data
    },
    toParentEventHandler(data) {
      console.debug(data)
    },
    onResizeEvent() {
      console.debug(
        'tableParentDom:',
        this.$refs.tableParentDom.getBoundingClientRect()
      )
      if (this.$refs.tableParentDom) {
        this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
      } else {
        console.debug('dom 不存在')
      }
    },
    computedModeData(data) {
      console.debug('computedModeData:', data)
      if (data && data.data) {
        let tableData = data.data.map((rowData) => {
          this.tableColumnData.forEach((columnItem) => {
            if (columnItem.widthVw) {
              columnItem.widthPx = Math.floor(columnItem.widthVw * this.vw2px)
            }

            if (columnItem.child) {
              columnItem.child.forEach((childItem) => {
                if (childItem.widthVw) {
                  childItem.widthPx = Math.floor(childItem.widthVw * this.vw2px)
                }
                if (columnItem.isAssignFlag) {
                  console.debug('columnItem:', columnItem)
                  if (childItem.originVal.length > 1) {
                    let originValArr = []
                    childItem.originVal.forEach((originItem) => {
                      originValArr.push(rowData[originItem])
                    })
                    rowData[childItem.prop] = originValArr.join('/')
                  } else {
                    rowData[childItem.prop] = rowData[childItem.originVal[0]]
                  }
                }
              })
            } else {
              if (columnItem.isAssignFlag) {
                rowData[columnItem.prop] = rowData[columnItem.originVal[0]]
              }
            }
          })
          return rowData
        })
        console.debug(
          'mode_25 this.tableData:',
          tableData,
          this.tableColumnData
        )
        const { team_logo, team_name, team_id, team_eng } = data.baseInfo
        return {
          key: data.key,
          tableData,
          team_logo,
          team_name,
          team_id,
          team_eng,
        }
      } else {
        console.debug('暂无数据')
        return this.notDataHandler(data.key)
      }
    },
    notDataHandler(key) {
      return {
        key: key,
        tableData: [],
        team_logo: '',
        team_name: '',
        team_id: '',
        team_eng: '',
      }
      //   this.tableData = []
    },
  },
}
</script>

<style lang="scss" scoped>
.eventComp_mode_container {
  width: 100%;
  padding: 1.388vw 0;
  .eventComp_mode_title {
    display: block;
    font-size: 1.11vw;
    line-height: 2.788vw;
    font-weight: bold;
    color: var(--mixtmt_mainColor5);
  }
  .tableScrollArea {
    width: 100%;
  }
  .tableGroup {
    position: relative;
    width: 100%;
    padding-bottom: 1.388vw;
    .groupInfor {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      height: 3.47vw;
      margin-bottom: 0.694vw;
      .groupInfor_logo {
        width: 2.91vw;
        height: 1.94vw;
        overflow: hidden;
        background-color: var(--mixtmt_greyColor0);
        &.isLogo {
          background-color: transparent;
        }
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .groupInfor_name {
        width: auto;
        padding: 0 2.083vw;
        font-size: 1.11vw;
        color: var(--mixtmt_greyColor3);
        font-weight: bold;
      }
    }
  }
}

.mixtmt_pc {
  .eventComp_mode_container {
    .tableGroup {
      .groupInfor {
        .groupInfor_name {
          &:hover {
            cursor: pointer;
            color: var(--mixtmt_subColor1_1);
            text-decoration: underline;
          }
        }
      }
    }
  }
}
</style>
